window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.uploadDocumentsBox = window.locales.am.uploadDocumentsBox || {};window.locales.am.uploadDocumentsBox = {...window.locales.am.uploadDocumentsBox, ...{
    "header": "ሰነዶችን ይጫኑ",
    "content": "ተቀባይነት ከተሰጠዎት፣ ለከፍተኛ ዲግሪዎ ኦፊሴላዊ ግልባጮችን እንፈልጋለን። አሁን ቀድመው ይጀምሩ።",
    "buttonUploadDocuments": "ሰነዶችን ይጫኑ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.uploadDocumentsBox = window.locales.ar.uploadDocumentsBox || {};window.locales.ar.uploadDocumentsBox = {...window.locales.ar.uploadDocumentsBox, ...{
    "header": "تحميل المستندات",
    "content": "إذا تم قبولك، سنحتاج إلى نسخ رسمية لأعلى درجة علمية حصلت عليها. احصل على السبق الآن.",
    "buttonUploadDocuments": "تحميل المستندات"
}
};window.locales.en = window.locales.en || {};window.locales.en.uploadDocumentsBox = window.locales.en.uploadDocumentsBox || {};window.locales.en.uploadDocumentsBox = {...window.locales.en.uploadDocumentsBox, ...{
    "header": "Upload Documents",
    "content": "If admitted, we'll need official transcripts for your highest degree. Get a head start now.",
    "buttonUploadDocuments": "Upload Documents"
}
};window.locales.es = window.locales.es || {};window.locales.es.uploadDocumentsBox = window.locales.es.uploadDocumentsBox || {};window.locales.es.uploadDocumentsBox = {...window.locales.es.uploadDocumentsBox, ...{
    "header": "Cargar documentos",
    "content": "Si es admitido, necesitaremos transcripciones oficiales de su título más alto. Comience ahora mismo.",
    "buttonUploadDocuments": "Cargar documentos"
}
};window.locales.it = window.locales.it || {};window.locales.it.uploadDocumentsBox = window.locales.it.uploadDocumentsBox || {};window.locales.it.uploadDocumentsBox = {...window.locales.it.uploadDocumentsBox, ...{
    "header": "Carica documenti",
    "content": "Se ammesso, avremo bisogno delle trascrizioni ufficiali per il tuo titolo più alto. Inizia subito.",
    "buttonUploadDocuments": "Carica documenti"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.uploadDocumentsBox = window.locales.zh.uploadDocumentsBox || {};window.locales.zh.uploadDocumentsBox = {...window.locales.zh.uploadDocumentsBox, ...{
    "header": "上传文件",
    "content": "如果被录取，我们将需要您最高学位的官方成绩单。现在就开始准备吧。",
    "buttonUploadDocuments": "上传文件"
}
};